import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-brand-white py-12 border-t border-brand-border pb-28 md:pb-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-10 items-center">
        
        <div className="flex items-center justify-center md:justify-start">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/ab03ff55dc7bcdd9e4a34a93308a2aa656b3e0baf34844f0be8f244dd21175025656600d9573a40a26a1591403a49a1d/images/aW1hZ2UvanBlZw==/4a5835b64db5a106236ab96fc7aa3e94.jpeg" 
            alt="White Knight Global Consulting" 
            className="h-16 md:h-20 object-contain mix-blend-multiply"
          />
        </div>

        <div className="text-center">
          <p className="text-sm font-bold text-brand-black mb-1">White Knight Global Consulting</p>
          <p className="text-sm text-brand-muted">Raffles Hotel Arcade</p>
          <p className="text-sm text-brand-muted mb-3">328 North Bridge Road #02-20</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm">
            <a href="mailto:admin@whiteknightgc.com" className="text-brand-gold hover:text-brand-black transition-colors">admin@whiteknightgc.com</a>
            <span className="hidden sm:block text-brand-muted">|</span>
            <a href="tel:988702334" className="text-brand-gold hover:text-brand-black transition-colors">988702334</a>
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-2 text-center md:text-right">
          <p className="text-sm text-brand-muted font-medium">
            &copy; {new Date().getFullYear()} White Knight Global Consulting.<br className="hidden lg:block"/> All rights reserved.
          </p>
          <p className="text-xs text-brand-gold font-bold tracking-widest uppercase mt-2">
            Strictly Confidential Advisory
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;